import { Component } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthorizationService } from './services/authorization.service';

@Component({
    selector: 'legendary-app',
    template: require('./legendary-app.component.html')
})
export class LegendaryAppComponent {
    public authenticationComplete: Observable<boolean>;
    name = 'Wheel of Fate';
    //public token: string;
    constructor(authorizationService: AuthorizationService) {
    }

    //ngOnInit() {
    //    this.token = localStorage.getItem('userToken');
    //}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/legendary-app.component.ts